import React from "react";
import { business, growth, platform, sub, trade, trust } from "../../assets";

/**
 * @author
 * @function HowItWorks
 **/

export const HowItWorks = (props) => {
  return (
    <section className="bg-secondary text-white lg:px-2 md:px-4 sm:px-4">
      <div className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12">
        <div>
          <div className="flex justify-center items-center">
            <h2 className="lg:text-3xl md:text-2xl sm:text-xl lg:px-0 md:px-0 sm:px-4">
              How WristLink Works
            </h2>
            {/* <h2 className="text-[28px] font-semibold">Why WristLink</h2> */}
          </div>

          <div className="lg:grid lg:grid-cols-[auto_auto_auto] sm:flex sm:flex-col gap-4">
            <div className="flex items-baseline">
              <div className="flex flex-col px-4 py-4 rounded items-center">
                <div className="rounded h-[200px] w-full flex justify-center items-center">
                  <img src={business} className="h-[100px]" />
                </div>
                <h2 className="text-[20px] text-center font-bold my-4">
                  Create an Account
                </h2>
                <p className="text-center">
                  Get started by creating an account and completing a quick
                  verification process to ensure a secure and professional
                  network.
                </p>
              </div>
              <div className="lg:block md:block sm:hidden">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="size-12"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3"
                  />
                </svg>
              </div>
            </div>

            <div className="flex items-baseline">
              <div className="flex flex-col px-4 py-4 rounded items-center">
                <div className="rounded h-[200px] w-full flex justify-center items-center">
                  <img src={sub} className="h-[100px]" />
                </div>
                <h2 className="text-[20px] text-center font-bold my-4">
                  Choose Your Subscription
                </h2>
                <p className="text-center">
                  Pick a subscription plan that suits your business needs. With
                  our commission-free model, you’ll enjoy a flat monthly rate
                  and complete cost transparency.
                </p>
              </div>

              <div className="lg:block md:block sm:hidden">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="size-12"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3"
                  />
                </svg>
              </div>
            </div>

            <div className="flex flex-col px-4 py-4 rounded items-center">
              <div className=" rounded h-[200px] w-full flex justify-center items-center">
                <img src={trade} className="h-[100px]" />
              </div>
              <h2 className="text-[20px] font-bold my-4">
                Connect and Trade with Ease
              </h2>
              <p className="text-center">
                Once you’re in, explore the network, connect with trusted
                dealers, and finalize trades on our secure platform. With
                WristLink, it’s trading made simple and efficient.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
